




















































































































































































































































































import Vue from 'vue';
import { AxiosVue } from '@/AxiosVue'; //
import { ServicioProxy } from '@/config/enums'; //
import config from '@/config/index'; //
import { ComponenteBaseStepper } from '../../views/base/ComponenteBaseStepper';
import { Component, Prop, Emit, Watch } from 'vue-property-decorator';
import HandleErrors from '@/config/handleErrors';
import { LoadingService } from '@/services/loadingService';
import Validadores from '@/config/validaRut';
import router from '../../router';
import { Validator } from 'vee-validate';
import store from '@/store';
import {
  GridOptions,
  GridApi,
  ColumnApi,
  ColDef,
  GridReadyEvent,
  RowNode,
  CellContextMenuEvent,
} from 'ag-grid-community';
const { AgGridVue } = require('ag-grid-vue');
import Confirmation from '@/components/Confirmation.vue'; //
import { fetchPassword } from '@/pantallas/Inicio/Sidebar/fetchPassword';

@Component({
  components: {
    'app-confirmacion': Confirmation,
  },
})
export default class ChangePass extends Vue {
  @Prop({ default: false }) show: boolean;
  @Prop({ default: true }) primerIngreso: boolean;

  //propiedades
  dialog: boolean = false;
  dialogConfirmacionClose: boolean = false;

  //
  $snotify: any;
  usuarioId: number = this.$store.state.userId;
  email: string = '';
  correoEnviado: boolean = false;
  userDataChangePass: any = {
    contrasena1: '',
    contrasena2: '',
    contrasena3: '',
  };
  validForm: boolean = false;
  validForm2: boolean = false;
  validFormActualizaPass: boolean = false;
  dictionaryFormErrors: any = {};
  handleErrors: HandleErrors = new HandleErrors();
  paso1_ok: boolean = false;
  show1: boolean = false;
  show2: boolean = false;
  show3: boolean = false;
  show4: boolean = false;
  username: string = '';
  recuperarPass: boolean = false;
  debeCambiarPass: boolean = false;
  contactarEjecutivo: boolean = false;
  axios: AxiosVue = new AxiosVue(ServicioProxy.Auth);
  Controller: string = 'Cuenta';
  controllerParametroSistema: string = 'ParametroSistema';
  axiosGestionUsuario: AxiosVue = new AxiosVue(ServicioProxy.GestionUsuario);
  passRules1: any = [];
  passRules2: any = [];
  passRules3: any = [];
  estadoUsuario: any;
  dialogSesionExpirada: boolean = false;
  dialogpermisosModificados: boolean = false;
  loadingService = new LoadingService();
  readonly controllerUi: string = 'EstadoUi';
  vr: Validadores = new Validadores();
  usuario: any = this.$store.state.user;
  modalLogout: boolean = false;
  axiosMetabase: AxiosVue = new AxiosVue(ServicioProxy.MetabaseAws);
  confirmacionAdicional: boolean = false;

  redireccionaAceptarInfo: string = '0';

  @Watch('show')
  onPropertyChanged(value: boolean, oldValue: boolean) {
    this.dialog = value;
    this.show1 = false;
    this.show2 = false;
    this.show3 = false;
    this.show4 = false;
    var formVal: any = this.$refs;
    formVal.form.reset();
    this.validFormActualizaPass = true;
    const model = {
      ClienteId: this.getClienteID(),
    };
  }

  closeModal(val: boolean) {
    this.userDataChangePass.contrasena1 = '';
    this.userDataChangePass.contrasena2 = '';
    this.show1 = false;
    this.show2 = false;
    this.show3 = false;
    this.show4 = false;
    this.userDataChangePass.contrasena3 = '';
    this.$emit('modalAsociacionEmit', false);
    this.dialog = false;
  }

  confirmCallbackConfirm(val: boolean) {
    this.dialogConfirmacionClose = false;
    if (val) {
      this.closeModal(false);
    }
    if (this.confirmacionAdicional) {
      this.getActualizarEstado();
      this.confirmacionAdicional = false;
    }
  }
  created() {
    //Redirección Aceptar Información
    this.redireccionaAceptarInfo = window.localStorage.getItem(
      'urlAceptarInformacion'
    );
    //---

    var sesionExpirada = window.localStorage.getItem('showSesionExpirada');
    if (sesionExpirada != null) {
      this.dialogSesionExpirada = true;
      this.loadingService.hideLoading();
      window.localStorage.removeItem('showSesionExpirada');
      console.clear();
    }

    var tokenModificado = window.localStorage.getItem('showLogoutPermisos');
    if (tokenModificado != null) {
      this.dialogpermisosModificados = true;
      this.loadingService.hideLoading();
      window.localStorage.removeItem('showLogoutPermisos');
      console.clear();
    }

    this.passRules1 = [(v: any) => !!v || config.errorMensajes.textoRequerido];
    this.passRules2 = [
      (v: any) => !!v || config.errorMensajes.textoRequerido,
      (v: any) => (v && v.length <= 20) || config.errorMensajes.maxLength,
      (v: any) =>
        (v && v.length >= 8) || '* El campo debe tener al menos 8 caracteres.',
      (v: any) =>
        this.userDataChangePass.contrasena2 ==
          this.userDataChangePass.contrasena3 ||
        config.errorMensajes.passNoIguales,
      (v: any) =>
        this.vr.validaFormatoPasswordv2(v) ||
        '* Formato de contraseña incorrecto (Vea reglas de contraseña).',
    ];
    this.passRules3 = [
      (v: any) => !!v || config.errorMensajes.textoRequerido,
      (v: any) => (v && v.length <= 20) || config.errorMensajes.maxLength,
      (v: any) =>
        (v && v.length >= 8) || '* El campo debe tener al menos 8 caracteres.',
      (v: any) =>
        this.userDataChangePass.contrasena2 ==
          this.userDataChangePass.contrasena3 ||
        config.errorMensajes.passNoIguales,
      (v: any) =>
        this.vr.validaFormatoPasswordv2(v) ||
        '* Formato de contraseña incorrecto (Vea reglas de contraseña).',
    ];

    this.dictionaryFormErrors = {
      custom: {
        email: {
          required: () => config.errorMensajes.textoRequerido,
          emailValido: () =>
            'El campo correo electrónico debe ser un correo válido',
        },
        contrasena: {
          required: () => config.errorMensajes.textoRequerido,
          confirmed: () => config.errorMensajes.passNoIguales,
          min: () => 'El campo debe tener al menos 8 caracteres.',
          max: () => config.errorMensajes.maxLength,
        },
        contrasena1: {
          required: () => config.errorMensajes.textoRequerido,
          confirmed: () => config.errorMensajes.passNoIguales,
          min: () => 'El campo debe tener al menos 8 caracteres.',
          max: () => config.errorMensajes.maxLength,
        },
        contrasena2: {
          required: () => config.errorMensajes.textoRequerido,
          confirmed: () => config.errorMensajes.passNoIguales,
          min: () => 'El campo debe tener al menos 8 caracteres.',
          max: () => config.errorMensajes.maxLength,
        },
        contrasena3: {
          required: () => config.errorMensajes.textoRequerido,
          confirmed: () => config.errorMensajes.passNoIguales,
          min: () => 'El campo debe tener al menos 8 caracteres.',
          max: () => config.errorMensajes.maxLength,
        },
      },
    };
    this.$validator.localize('es', this.dictionaryFormErrors);
  }
  changeInput() {
    var formVal: any = this.$refs;
    formVal.form.validate();
  }
  actualizarPassLogin() {
    var formVal: any = this.$refs;
    if (formVal.form.validate()) {
      //valida contraseña
      if (
        this.vr.validaFormatoPasswordv2(
          this.userDataChangePass.contrasena2.toString().trim()
        ) === true
      ) {
        let validaModel: any = {
          NombreUsuario: this.usuario.email,
          Contrasena: this.userDataChangePass.contrasena1,
          NuevaContrasena: this.userDataChangePass.contrasena2,
          RepetirContrasena: this.userDataChangePass.contrasena3,
          token: window.localStorage.token,
          origen: window.location.origin,
        };
        if (
          this.userDataChangePass.contrasena1 ===
          this.userDataChangePass.contrasena2
        ) {
          this.$snotify.warning(
            'Nueva contraseña no puede ser igual a la anterior.'
          );
          return;
        }
        this.loadingService.showLoading();
        let self = this;

        this.axiosMetabase.http
          .post(`Metabase/PostgenericA/track/change_password`, validaModel)
          .then(res => {
            if (res.data.CODIGO_RESPUESTA == '1') {
              this.axios.http
                .put(`${this.Controller}/${this.usuarioId}/cambiarEstado`)
                .then(res => {
                  this.modalLogout = true;
                  self.loadingService.hideLoading();
                  self.getActualizarEstado();
                })
                .catch(error => {
                  self.loadingService.hideLoading();
                  self.$snotify.error(
                    'Ocurrio un error al actualizar estado de usuario.'
                  );
                });
            } else {
              self.loadingService.hideLoading();
              self.$snotify.error(res.data.MENSAJE_RESPUESTA);
            }
          })
          .catch(err => {
            self.loadingService.hideLoading();
            self.$snotify.error('Error de conexión');
          });

        /*this.axios.http
          .post(`${this.Controller}/checkCurrentPassword`, validaModel)
          .then(res => {
            let model: any = {
              UsuarioId: this.usuarioId,
              Contrasena: this.userDataChangePass.contrasena2,
              RepetirContrasena: this.userDataChangePass.contrasena3,
            };
            this.axios.http.post('');

            this.axios.http
              .post(`${this.Controller}/changepass`, model)
              .then(res => {
                this.axios.http
                  .put(`${this.Controller}/${this.usuarioId}/cambiarEstado`)
                  .then(res => {
                    this.modalLogout = true;
                  })
                  .catch(error => {
                    this.$snotify.error(
                      'Ocurrio un error al actualizar estado de usuario.'
                    );
                  });
              })
              .catch(error => {
                if (error.response.status == '409') {
                  this.$snotify.warning(
                    'La contraseña debe ser distinta a las últimas 3 utilizadas'
                  );
                } else {
                  this.$snotify.error(
                    'Ocurrio un error al actualizar contraseña.'
                  );
                }
              });
          })
          .catch(err => {
            this.$snotify.error('Contraseña actual incorrecta.');
          });*/
      } else {
        this.$snotify.error(
          'Contraseña no cumple las reglas básicas de validación para su generación.'
        );
      }
      //}
    }
  }
  getClienteID() {
    return config.getClienteSesion();
  }
  async ejecutaLogout() {
    this.modalLogout = false;
    this.paso1_ok = false;
    this.recuperarPass = false;
    this.debeCambiarPass = false;
    window.localStorage.setItem('logout', '1');

    // Auditar logout por cambio de contraseña
    await this.axiosMetabase.http.post('Metabase/PostgenericA/usuario/audit', {
      clientid: store.state.user.clienteDefecto,
      rut_cliente: store.state.user.hasOwnProperty('rutClienteDefecto')
        ? store.state.user.rutClienteDefecto
        : '',
      userid: store.state.user.id,
      email: store.state.user.email,
      event: 'LOGOUT',
      message: 'Cierre de sesión por cambio de contraseña',
    });

    this.$store.dispatch('logout');
    this.$snotify.clear();
  }

  async getActualizarEstado() {
    let self = this;
    this.loadingService.showLoading();

    return fetchPassword(
      { email: this.usuario.email.toUpperCase() },
      'track3_funcionalidades/getActualizarEstado'
    ).then((data: any) => {
      if (data.data.CODIGO_RESPUESTA == '1') {
        self.loadingService.hideLoading();
        return null;
      } else {
        self.loadingService.hideLoading();
        self.$snotify.error(data.data.MENSAJE_RESPUESTA, { timeout: 3000 });
      }
    });
  }
}
